module.exports = __webpack_public_path__ + "static/media/caballito.1835c597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clubs/caballito.jpg
// module id = 89
// module chunks = 0